module.exports = __webpack_public_path__ + "static/media/build_icon.535be1eb.svg";